
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ArchiveOperation enum
 */
class ArchiveOperation {
  /**
   * Initialize enum with a given value
   * @param {ArchiveOperation|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ArchiveOperation) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ArchiveOperation}
   * @param {!ArchiveOperation} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ArchiveOperation)) {
      throw new TypeError('Instance of ArchiveOperation is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ArchiveOperation}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ArchiveOperation}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ArchiveOperation.ARCHIVE.value) {
      return 'ARCHIVE'
    }
    if (this.value === ArchiveOperation.RESTORE.value) {
      return 'RESTORE'
    }
    if (this.value === ArchiveOperation.DELETE_ARCHIVED.value) {
      return 'DELETE_ARCHIVED'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ArchiveOperation}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ArchiveOperation}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ArchiveOperation} Created enum
   */
  static fromObject (other) {
    return new ArchiveOperation(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ArchiveOperation.ARCHIVE = new ArchiveOperation(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ArchiveOperation.RESTORE = new ArchiveOperation(1 + 0)
// noinspection PointlessArithmeticExpressionJS
ArchiveOperation.DELETE_ARCHIVED = new ArchiveOperation(2 + 0)

export { ArchiveOperation };

/**
 * Fast Binary Encoding ArchiveOperation field model
 */
class FieldModelArchiveOperation extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelArchiveOperation}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelArchiveOperation}
   * @param {ArchiveOperation=} defaults Default value, defaults is new ArchiveOperation()
   * @returns {!ArchiveOperation} Result value
   */
  get (defaults = new ArchiveOperation()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ArchiveOperation(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelArchiveOperation}
   * @param {!ArchiveOperation} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelArchiveOperation };
